import aiNativeBehaviorEvaluator from './aiNativeBehaviorEvaluator';

/**
 * Web-native aiPromptBehavior: calls AI LLM generate via aiNativeBehaviorEvaluator.
 * Same contract as server: source.prompt (prefix), optional source.content (override);
 * if source.content === undefined, use content; else use source.content.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const resolvedPromptPrefix = sourceEvaluator ? await sourceEvaluator(source.prompt) : source.prompt;
  const providedContent = source.content;
  let resolvedContent;
  if (providedContent !== undefined) {
    resolvedContent = sourceEvaluator ? await sourceEvaluator(providedContent) : providedContent;
  } else {
    resolvedContent = content;
  }
  const aiPrompt = `${resolvedPromptPrefix}\n: ${JSON.stringify(resolvedContent)}`;
  const response = await aiNativeBehaviorEvaluator.llmGenerate(aiPrompt);
  return response;
};
export default {
  evaluate
};